import { render, staticRenderFns } from "./commodityList.vue?vue&type=template&id=5875c15a&scoped=true"
import script from "./commodityList.vue?vue&type=script&lang=js"
export * from "./commodityList.vue?vue&type=script&lang=js"
import style0 from "./commodityList.vue?vue&type=style&index=0&id=5875c15a&prod&lang=less"
import style1 from "./commodityList.vue?vue&type=style&index=1&id=5875c15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5875c15a",
  null
  
)

export default component.exports